module.exports = __webpack_public_path__ + "static/media/Google_Youtube.20da096a.png";